<love-it-modal-header
  (close)="modal.dismiss()"
  title="Konflikt"></love-it-modal-header>
<div class="modal-body">
  <div class="alert-triangle">
    <i class="feather icon-alert-triangle"></i>
  </div>
  Dieser Datensatz wurde bereits von einer anderen Person bearbeitet und konnte daher nicht gespeichert werden. Bitte
  öffnen Sie den Datensatz erneut und nehmen Sie Ihre Änderungen nochmals vor.
</div>
<div class="modal-footer">
  <button
    (click)="modal.dismiss()"
    class="btn-mobile-group btn-primary"
    rippleEffect
    type="button">
    OK
  </button>
</div>
